import React from 'react';

import { IPlansListFields } from '../../../types/contentful';

import { PlanInfo } from './PlanInfo';
import { ScrollReveal } from '../ScrollReveal';

interface Props extends IPlansListFields {
  sysId?: string;
}

export function PlansList({ plans, heading, sysId }: Props) {
  return (
    <ScrollReveal>
      <div
        className="mt-12 mb-12 flex w-full justify-center scroll-mt-16 tablet:mt-16 tablet:mb-16"
        data-eltype="plan-list"
        data-blockid={sysId}
        data-testid="plansList"
      >
        <div className="flex w-full max-w-[1440px] flex-wrap justify-center gap-4 px-3 tablet:gap-6 tablet:px-12">
          {!!heading && (
            <div className="flex w-11/12 shrink-0 grow-0 justify-center pb-6 text-left tablet:text-center">
              <h2
                className="font-glRepro font-medium text-black text-[1.75rem] leading-8 tablet:text-[2rem] tablet:leading-9 desktop:text-[2.625rem] desktop:leading-[3rem]"
                data-elementid="plan-list-heading"
                dangerouslySetInnerHTML={{ __html: heading || '' }}
              />
            </div>
          )}
          <div className="flex min-w-0 max-w-[312px] shrink-0 grow-0 flex-col tablet:max-w-none tablet:w-11/12 max:w-10/12">
            <div
              role="list"
              className="mx-auto flex w-full flex-col tablet:flex-row tablet:flex-wrap tablet:justify-start desktop:flex-nowrap desktop:justify-between"
            >
              {(plans || []).map(({ sys, fields }) => (
                <PlanInfo {...fields} key={sys?.id} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
}
